<template>
  <div>
    <Header></Header>
    <template v-if="loginUserInfo && loginUserInfo.school_code&&school_code">
      <div class="containear" v-if="school_code == services.SXYXLX_CODE">
        <img src="../../../assets/custom/sxyxlx/background.jpg" @click="jumpCenter()">
      </div>
      <div class="banner-swiper" v-else>
        <swiper :options="swiperOption">
          <swiper-slide v-for="img,index in bannerList" :key="index" @click="jumpCenter">
            <a class="thumb-image" :href="`/center/${school_code}/user/myClass`" target="_self" :style="`background:url(${img})no-repeat center/cover`" />
          </swiper-slide>

        </swiper>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </template>

  </div>
</template>

<script>
import Header from "@/components/Header"
import utils from '../../../config/utils'
import services from "../../../config/services";

import { mapState, mapActions } from "vuex";
export default {
  data () {
    return {
      services,
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      bannerList: [require("../../../assets/yxlx/yxlx-1.jpg"), require("../../../assets/yxlx/yxlx-2.jpg")], // 顶部轮播图
      swiperOption: {
        observer: true,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  components: {
    Header
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  mounted () {
    this.getAppsLoginUserInfo().then(res => {
      if (res.data.school_code != this.school_code) {
        window.open(`/center/${res.data.school_code}/custom/sxyxlx`, "_self")
      }

      //  res.data.school_code != services.YXLX_CODE  100041下线研学旅行 20251031
      if (res.data.school_code != services.SXYXLX_CODE) {
        this.jumpCenter()
      }
    })

  },
  methods: {
    ...mapActions(['getAppsLoginUserInfo']),

    jumpCenter () {
      window.open(`/center/${this.school_code}/user/myClass`, "_self")
    }
  }
}
</script>

<style lang="less" scoped>
.containear {
    overflow: hidden;
    img {
        width: 100%;
        cursor: pointer;
    }

    .swiper-container {
        height: 100%;
    }
}
.banner-swiper {
    width: 100%;
    height: auto;
    position: relative;
    .thumb-image {
        display: block;
        width: 100%;
        height: auto;
        aspect-ratio: 2200/1123;
    }
    .swiper-container {
        height: 100%;
    }

    .swiper-pagination {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 21px;
        z-index: 1;
        ::v-deep .swiper-pagination-bullet {
            display: inline-block;
            &.swiper-pagination-bullet-active {
                width: 20px;
                height: 10px;
                background: #ffffff;
                border-radius: 5px;
                border: 1px solid #5c2715;
            }
            width: 6px;
            height: 6px;
            background: #5c2715;
            border-radius: 50%;
            vertical-align: middle;
            &:not(:last-child) {
                margin-right: 8px;
            }
        }
    }
    .swiper-button-next,
    .swiper-button-prev {
        position: absolute;
        top: 50%;
        // top: 112px;
        cursor: pointer;
        z-index: 10;
        width: 36px;
        height: 100px;
        transform: translateY(-50%);
        opacity: 0.9;
        &.swiper-button-disabled {
            opacity: 0.6;
        }
        &:hover {
            opacity: 1;
        }
    }
    .swiper-button-next {
        background: url('../../../assets/custom/party/project/index/swiper-next.png')
            no-repeat center/cover;
        // right: -66px;
        right: 50px;
    }
    .swiper-button-prev {
        background: url('../../../assets/custom/party/project/index/swiper-prev.png')
            no-repeat center/cover;
        // left: -66px;
        left: 50px;
    }
}
</style>